import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { decodeJWT } from '../utils/DecodeJWT';

const Username = () => {
  const [username, setUsername] = useState('');
  const location = useLocation();

  // Map routes to titles or derive dynamically
  const getTitle = (pathname) => {
    const path = pathname.replace(/^\/+/, '');
    if (!path) return 'Matrimonial';
    switch (path) {
      case 'about':
        return 'About';
      default:
        return path.charAt(0).toUpperCase() + path.slice(1).toLowerCase();
    }
  };

  const title = getTitle(location.pathname);

  useEffect(() => {
    const token = localStorage.getItem('access_token');
    if (token) {
      const decoded = decodeJWT(token);
      if (decoded && decoded.username && typeof decoded.username === 'string') {
        // Split into name parts, filter out empty, and capitalize
        const nameParts = decoded.username
          .trim()
          .split(/\s+/)
          .filter(part => part.length > 0)
          .map(part => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase());
        // Set username only if there are valid parts
        if (nameParts.length > 0) {
          setUsername(nameParts.join(' '));
        }
      }
    }
  }, []);

  return (
    <div className="flex items-center justify-between p-4 bg-gradient-to-b from-blue-700 via-blue-700 to-blue-600 text-white">
      <div className="w-1/3"></div>
      <div className="w-1/3 text-center">
        <h1 className="text-4xl font-semibold">{title}</h1>
      </div>
      {/* Username on the right, only if username exists */}
      {username && (
        <div className="w-1/3 text-end">
          <span className="text-xl font-semibold text-white">
            {username}
          </span>
        </div>
      )}
    </div>
  );
};

export default Username;